<template>
    <section class="form-submission-card">
        <submission-title title_line_2="Progress Updates" />

        <loader v-if="loading"></loader>

        <comment
            v-for="(comment, index) in comments_list ?? []"
            :key="`comment:${index}`"
            :comment="comment"
        />

        <submission-subtitle
            v-if="!loading && !comments_list?.length"
            subtitle_line_1="No updates provided"
        />

        <button
            v-else-if="next_page_url"
            class="btn btn-primary"
            @click="loadNext"
        >
            Load More
        </button>
    </section>
</template>

<script>
    import Loader from '../general_components/Loader.vue';
    import SubmissionTitle from '../submissions/SubmissionTitle.vue';
    import SubmissionSubtitle from '../submissions/SubmissionSubtitle.vue';
    import Comment from './Comment.vue';

    export default {
        name: 'Comments',

        components: {
            Loader,
            Comment,
            SubmissionTitle,
            SubmissionSubtitle,
        },

        props: {
            endpoint: String,
            pdf_mode: {
                type: Boolean,
                default: false,
            },
            comments: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                next_page_url   : null,
                loading         : false,
                comments_list   : this.comments,
            };
        },

        methods: {
            loadNext: function () {
                this.loading = true;

                axios.get(this.next_page_url ?? this.endpoint)
                    .then((response) => {
                        this.comments_list = [...this.comments_list, ...response.data.data];
                        this.next_page_url = response.data.links.next;

                        this.loading = false;
                    })
            }
        },

        mounted: function () {
            if (!this.pdf_mode) {
                this.loadNext();
            }
        }
    }
</script>
